/**
 * Checks if the current environment is an E2E test environment.
 * This is detected via a global variable injected by Playwright's addInitScript.
 * @returns true if running in an E2E test environment, false otherwise
 */
export function isE2ETest(): boolean {
  return typeof window !== 'undefined' && (window as { __PLAYWRIGHT_TEST__?: boolean }).__PLAYWRIGHT_TEST__ === true
}
